import React from 'react'
import styles from './icon.module.scss'
import { type IconImage } from './icon.types'

export type { IconImage }

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions -- Props extends a DOM attributes interface; interface extension is idiomatic here
export interface IconProps extends React.HTMLAttributes<HTMLElement> {
  iconImage: IconImage
  size: 'large' | 'small' | 'xl' | 'xs'
  sizeS?: 'large' | 'small' | 'xl' | 'xs'
  preserveDesktopSize?: boolean
}

export const Icon: React.FC<IconProps> = ({
  iconImage,
  size,
  sizeS = size,
  preserveDesktopSize = false,
  className,
  ...props
}) => {
  const classes = [
    styles.icon,
    `icon-${iconImage}`,
    styles[`icon--${size}`],
    !preserveDesktopSize ? styles[`icon--${sizeS}-s`] : '',
    className ?? '',
  ].filter(Boolean).join(' ')

  return <span className={classes} {...props}></span>
}
